<script>
import { ArrowUpIcon } from 'vue-feather-icons';

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

export default {
    data() {
        return {}
    },
    components: {
        Navbar,
        Footer,
        ArrowUpIcon
    }
}
</script>

<template>
<div>
    <Navbar />

    <!-- Hero Start -->
    <section class="bg-half-170 bg-light d-table w-100">
        <div class="container">
            <div class="row mt-5 justify-content-center">
                <div class="col-lg-12 text-center">
                    <div class="pages-heading">
                        <h2 class="title mb-0">Brother Products & Solutions</h2>
                        <span class="badge badge-pill badge-warning mt-3 px-3 py-2">Coming Soon</span>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="position-relative">
        <div class="shape overflow-hidden text-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
            </svg>
        </div>
    </div>
    <!-- Hero End -->

    <!-- Coming Soon Section - Two Columns -->
    <section class="section">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-4 col-md-5 text-center mb-4 mb-md-0">
                    <img src="/images/brands/brother.png" class="img-fluid" style="max-width: 200px;" alt="Brother Logo" />
                </div>
                <div class="col-lg-8 col-md-7">
                    <div class="section-title text-center text-md-left">
                        <h3 class="title mb-4">Brother Partnership Coming Soon</h3>
                        <p class="text-muted para-desc mb-4">
                            We are currently in the process of adding Brother to our product lineup. Stay tuned for updates on availability.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Features Coming Soon -->
            <!-- <div class="row mt-5">
                <div class="col-lg-4 col-md-6 mt-4 pt-2">
                    <div class="card border-0 rounded shadow text-center p-4">
                        <div class="icons text-primary text-center mx-auto mb-3">
                            <i class="uil uil-print d-block rounded h3 mb-0"></i>
                        </div>
                        <h5>Printers & All-in-Ones</h5>
                        <p class="text-muted mb-0">Reliable inkjet and laser printers for home and office environments.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 mt-4 pt-2">
                    <div class="card border-0 rounded shadow text-center p-4">
                        <div class="icons text-primary text-center mx-auto mb-3">
                            <i class="uil uil-tag-alt d-block rounded h3 mb-0"></i>
                        </div>
                        <h5>Labeling Solutions</h5>
                        <p class="text-muted mb-0">Professional labeling systems for organization and identification needs.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 mt-4 pt-2">
                    <div class="card border-0 rounded shadow text-center p-4">
                        <div class="icons text-primary text-center mx-auto mb-3">
                            <i class="uil uil-file-search-alt d-block rounded h3 mb-0"></i>
                        </div>
                        <h5>Scanners</h5>
                        <p class="text-muted mb-0">High-quality document scanners for efficient digitization workflows.</p>
                    </div>
                </div>
            </div> -->
        </div>
    </section>


    <Footer />
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
</div>
</template>
